/*eslint-disable */

import axios from 'axios';
import { bus } from '@/main';
import root from '@/_helpers/roots';
import updatePpDetails from '../../save-paper-info';

let paperUploadFromQuery = root.uploadPDFFromQueryApiUrl.link;

export default {
  name: 'add-paper-from-query',
  components: {
    'update-pp-details' : updatePpDetails
  },
  props: [],
  data () {
    return {
      submitted:false,
      search_term:'',
      savePaperPopupState:false,
      paperUpdateInfo:null,
      searchResultPaperData:null,
      searchResultPapers:[],
      loader:false
    }
  },
  computed: {

  },
  mounted () {
    bus.$on('savePaperPopupStateBus', (data) => {
      this.savePaperPopupState = data;
    });
  },
  methods: {
    updatePpDetailMethod(data){
      this.paperUpdateInfo = data
      this.savePaperPopupState = true
      document.body.classList.add('body_right_scroll_remove')
      // this.searchResultPaperData = null
      // this.searchResultPapers = []
    },
    getPaperPileListAgain(){
      this.$store.dispatch('getAllPaperPileFun')
    },
    searchPaperBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.searchResultPaperData = null
          this.searchResultPapers = []
          this.loader =  true
          axios.get(paperUploadFromQuery + '?query=' + this.search_term).then((res) => {
            this.searchResultPaperData = res.data.data
            this.searchResultPapers = this.searchResultPaperData.result
            this.loader =  false
          }).catch((err) => {
            this.loader =  false
          })
          return;
        }
      })
    },
    closeCreatePaperpilePopup(){
      bus.$emit('addPaperPilePopupStateBus', false);
      document.body.classList.remove('body_right_scroll_remove')
    },
    keymonitor(){
      if( this.passwordIncorrectState == true){
        this.passwordIncorrectState = false
      }
    }
  }
}